<template>
  <div>
    <b-container v-if="!!petOwnerOrderMessage">
      <b-row>
        <b-col cols="12" sm="12" md="10" offset-md="1" lg="8" offset-lg="2" xl="8" offset-xl="2">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <b-alert variant="warning" :show="!!petOwnerOrderMessage" v-html="petOwnerOrderMessage" />
        </b-col>
      </b-row>
    </b-container>
    <base-container>
      <h1 class="mt-4 mb-3 text-center text-lg font-weight-bold">{{ $t('views.confirmation.thanks') }}</h1>
      <h2 class="font-weight-bold text-dark text-center mb-1">{{ $t('views.confirmation.orderNumber', [order.id]) }}</h2>
      <h3 class="text-dark text-center">{{ $t('views.confirmation.gettingReady') }}</h3>

      <b-button :href="orderHistoryPageLink" class="mt-4" variant="primary" block>
        {{ $t('views.confirmation.viewOrder') }}
      </b-button>
      <b-button :href="accountLink" class="mt-2 mb-5" variant="outline-primary" block>
        {{ $t('views.confirmation.toAccount') }}
      </b-button>

      <h3 class="font-weight-bold text-dark mb-1">{{ $t('views.confirmation.summary') }}</h3>
      <hr class="mt-0" />
      <totals />
    </base-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import totals from '@/components/basket/Totals.vue';
import BaseContainer from '@/components/BaseContainer';

export default {
  components: {
    totals,
    BaseContainer,
  },
  computed: {
    ...mapState({
      order: (state) => state.order.order,
      locale: (state) => state.locale,
      petOwnerOrderMessage: (state) => state.order?.order?.city?.petOwnerOrderMessage,
    }),
    accountLink() {
      return `${window.BASE_URL}/${this.locale}/account/full/account-app`;
    },
    orderHistoryPageLink() {
      return `${this.accountLink}/settings/order-history`;
    },
  },
  created() {
    if (!this.order?.id) {
      this.$router.push({ name: 'Basket' });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
#donation-success-icon {
  color: $dp-green;
  background-color: $dp-white;
  border-radius: 100%;
}
</style>
